import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    allCollections: 'Voir toutes les collections',
    allIntegrations: 'Voir toutes les intégrations',
    allOffers: 'Voir toutes les offres',
    collections: 'Collections',
    description: 'Les outils et services que vous allez adorer.',
    highlightedOffers: 'Offres du moment',
    highlightedOffersCatchline:
      'Nous avons sélectionné pour vous les meilleures offres du moment',
    integrations: 'Intégrations',
    offers: 'Offres',
    title: 'Partners',
  },
  fr: {
    allCollections: 'Voir toutes les collections',
    allIntegrations: 'Voir toutes les intégrations',
    allOffers: 'Voir toutes les offres',
    collections: 'Collections',
    description: 'Les outils et services que vous allez adorer.',
    highlightedOffers: 'Offres du moment',
    highlightedOffersCatchline:
      'Nous avons sélectionné pour vous les meilleures offres du moment',
    integrations: 'Intégrations',
    offers: 'Offres',
    title: 'Partenaires',
  },
});

export default locales;
